<template>
  <div class="col-12" data-test="region-export">
    <div class="tab-content">
      <ExportLogic
        :panel-title="trans('region.regionExports')"
        :available-exports="availableExports"
        :export-url="'/api/internal/region-admin/export'"
        :load-data="getCenters"
        role="region_admin"
      />
    </div>
  </div>
</template>

<script>
import ExportLogic from "../../app/practitioner-portal/generic/export/ExportLogic.vue";

export default {
  components: {
    ExportLogic,
  },
  data() {
    return {
      centers: [],
    };
  },
  methods: {
    getCenters(update) {
      update({ isLoading: true });
      axios
        .get(
          "/api/internal/regions/" +
            this.$store.state.user.primaryCenter.region_id +
            "/centers",
        )
        .then((response) => {
          update({
            availableCenters: response.data.map((center) => ({
              id: center.id,
              text: center.name,
            })),
            isLoading: false,
          });
        })
        .catch((error) => {
          update({ isLoading: false });
        });
    },
  },
};
</script>
